import React from 'react';
import {View} from 'react-native';

import Gutter from '/component/layout/Gutter';
import {ProfileHeader} from '/component/screen/ReferralProfile/ProfileHeader';

import {styles} from './Header.style';
interface HeaderProps {
  name: string | undefined;
  source: string | undefined;
  createdOn: string | undefined;
  candidateId: string | null;
  referrerName: string | undefined;
  expirationTime: string | undefined;
  isDateExpired: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  name = '',
  source = '',
  createdOn = '',
  candidateId = null,
  referrerName = '',
  expirationTime = '',
  isDateExpired = false,
}) => (
  <View style={styles.base}>
    <Gutter>
      <ProfileHeader
        name={name}
        source={source}
        createdOn={createdOn}
        // @ts-expect-error TS(2322): Type '{ name: any; source: any; createdOn: any; op... Remove this comment to see the full error message
        optaviaId={candidateId}
        referrerName={referrerName}
        expirationTime={expirationTime}
        expired={isDateExpired}
      />
    </Gutter>
  </View>
);

export default Header;
